/**
 * Short timezone labels for display (#1032).
 *
 * One table, previously duplicated as TZ_SHORT_LABELS in SchedulePreview.tsx
 * and SHORT_ZONE_LABELS in components/connectors/schedule/scheduleTime.ts.
 *
 * THE RULE THIS MODULE EXISTS TO ENFORCE:
 *
 *   A RECURRING RULE ("daily at 2 AM") takes the FIXED short label — "ET" —
 *   because no Intl-derived abbreviation is correct year-round.
 *
 *   A SPECIFIC INSTANT (a projected run time) keeps its Intl-derived
 *   abbreviation — "EDT" or "EST". See instantZoneAbbr in
 *   components/connectors/schedule/scheduleTime.ts, and formatPreviewDateTime
 *   in components/connectors/schedule/SchedulePreview.tsx.
 *
 * Do not "unify" those two — they are deliberately different.
 */
const SHORT_ZONE_LABELS: Readonly<Record<string, string>> = {
  'America/New_York': 'ET',
  'America/Chicago': 'CT',
  'America/Denver': 'MT',
  'America/Los_Angeles': 'PT',
  UTC: 'UTC',
};

/**
 * The short label for a zone, or the raw IANA id when unknown — still
 * correct, just verbose.
 */
export function shortZoneLabel(tz: string): string {
  return SHORT_ZONE_LABELS[tz] ?? tz;
}
